export const PERMS = {
    READ: 'report_cost_center_performance.read',
    UPDATE: 'report_cost_center_performance.update',
    DELETE: 'report_cost_center_performance.delete',
    CREATE: 'report_cost_center_performance.create',
    EXPORT: 'report_cost_center_performance.export',
}
